import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchLcaAndBwv } from "../../../../redux/slices/LcaAndBwvSlice";

const LcaFilterLogic = ({ currentPage }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    searchText,
    selectedSubCategory,
    selectedItem,
    radius,
    searchTerm,
    activeTab,
    city,
    sortBy,
    month,
  } = useSelector((state) => state.lcAds);

  const { onlineView } = useSelector((state) => state.lcaAndVendors);
  const { users } = useSelector((state) => state.socket);
  const allUsers = Array.isArray(users) ? users : [];

  const urlParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const selected = urlParams.get("tab");
  const onlineUserIds = useMemo(() => {
    return allUsers
      .filter((user) => user.onlineStatus === "online")
      .map((user) => user.Id)
      .join(",");
  }, [allUsers]);
  const stableSelectedSubCategory = useMemo(
    () => ({
      id: selectedSubCategory?.id,
      Name: selectedSubCategory?.Name,
    }),
    [selectedSubCategory?.id, selectedSubCategory?.Name]
  );

  const stableSelectedItem = useMemo(
    () => ({
      subCatItemName: selectedItem?.subCatItemName,
    }),
    [selectedItem?.subCatItemName]
  );

  useEffect(() => {
    const params = {
      itemName:
        stableSelectedItem.subCatItemName ||
        (stableSelectedSubCategory.id !== 63
          ? stableSelectedSubCategory.Name
          : undefined) ||
        undefined,
      searchText: searchText || undefined,
      eventDetails: month || undefined,
      Zipcode: searchTerm && searchTerm.length >= 5 ? searchTerm : undefined,
      Radius: searchTerm && searchTerm.length >= 5 ? radius : undefined,
      pageId: currentPage,
      ...(stableSelectedSubCategory.id === 63
        ? selected === "Customers" || activeTab === "Customers"
          ? { engagedCouple: 1, type: "need", postStatus: 1 }
          : { postStatus: 10 }
        : { postStatus: 10 }),
      placeName: city || undefined,
      Sorting: sortBy || undefined,
      pageSize: 10,
      onlineUserId: onlineView ? onlineUserIds : undefined,
    };
    const debounceTimeout = setTimeout(() => {
      dispatch(fetchLcaAndBwv(params));
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [
    stableSelectedSubCategory,
    stableSelectedItem,
    searchText,
    radius,
    searchTerm,
    activeTab,
    city,
    sortBy,
    currentPage,
    onlineView,
    // onlineUserIds,
    selected,
    dispatch,
    month,
  ]);

  return null; // logic-only component
};

export default LcaFilterLogic;
